/* eslint-disable no-nested-ternary */
import { alpha } from '@mui/material/styles';
import { isEmpty } from 'lodash';

export const contactLeadDialogStyle = (type) => ({
    zIndex: type === 'onboarad' ? 1117 : 1200,
    margin: { xs: '0 -16px', sm: 0 },
    '.MuiDialog-paperFullScreen': {
        bgcolor: '#F4F6F8'
    }
});
export const commonDialogHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: { sm: 'row' },
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    p: '16px 24px !important',
    background: 'linear-gradient(135deg, #00A76F 0%, #007867 100%)',
    boxShadow: '0 2px 12px rgba(0, 167, 111, 0.15)',
    '@media (max-width: 768px)': {
        p: '10px 16px !important',
    },
};
export const contactLeadTitleStyle = {
    fontSize: { xs: '14px !important', sm: '18px !important' },
    color: '#fff',
    lineHeight: '24px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
export const cancelBoxStyle = () => ({
    display: 'flex',
    justifyContent: 'center',
    lineHeight: 0
});
export const contactLeadCancelButtonStyle = {
    borderColor: 'rgba(255, 255, 255, 0.5)',
    color: '#fff',
    height: { xs: '32px', sm: '36px' },
    fontSize: { xs: '12px', sm: '14px' },
    fontWeight: 500,
    p: { xs: '4px 14px', sm: '6px 20px' },
    borderRadius: 1.5,
    backdropFilter: 'blur(4px)',
    bgcolor: 'rgba(255, 255, 255, 0.08)',
    transition: 'all 0.2s ease',
    '&:hover': {
        bgcolor: 'rgba(255, 255, 255, 0.16)',
        borderColor: 'rgba(255, 255, 255, 0.7)',
    }
};
export const leadFooterButtonsStyle = (activeBackButton, type) => ({
    mt: 3,
    display: 'flex',
    // eslint-disable-next-line no-nested-ternary
    justifyContent: !activeBackButton ? type === 'followup' ? 'center' : 'flex-end' : 'space-between',
    pr: { xs: 4 },
    pl: { xs: 4 },
    flexWrap: 'wrap'
});
export const onBoardFooterButtonsStyle = activeBackButton => ({
    mt: 3,
    display: 'flex',
    justifyContent: !activeBackButton ? 'flex-end' : 'space-between',
    pr: { sm: 7, xs: 4 },
    pl: { sm: 5, xs: 4 },
    flexWrap: 'wrap'
});
export const tabButtonBoxStyle = {
    width: '100%',
    textAlign: 'center',
    marginTop: '-30px',
    '@media (max-width: 768px)': {
        marginTop: '-20px',
    },
};
export const tabButtonGroupStyle = {
    border: 'none',
    flexDirection: 'row',
    maxWidth: '100%',
    borderRadius: '0',
    padding: '0',
    marginBottom: '18px'
};
export const contactLeadButtonStyle = outcome => ({
    borderRadius: '0 !important',
    ':hover': { backgroundColor: 'transparent', border: 'none' },
    color: outcome === 'Contact Lead' ? '#212B36' : '#637381',
    border: 'none',
    fontSize: { xs: '12px', sm: '14px' },
    boxShadow: 'none',
    padding: { xs: '8px 12px', sm: '12px 16px' },
    marginRight: { xs: '0', sm: '24px' },
    marginLeft: '0 !important',
    justifyContent: 'center',
    textAlign: 'center',
    width: { xs: '50%', sm: '322px' },
    borderBottom: outcome === 'Contact Lead' ? 'solid 1px #00AB55 !important' : 'solid 1px  transparent'
});
export const timelineButtonStyle = outcome => ({
    borderRadius: '0 !important',
    ':hover': { backgroundColor: 'transparent', border: 'none' },
    color: outcome === 'Timeline' ? '#212B36' : '#637381',
    border: 'none',
    fontSize: { xs: '12px', sm: '14px' },
    boxShadow: 'none',
    padding: { xs: '8px 12px', sm: '12px 16px' },
    marginRight: { md: '0', xs: '0' },
    marginLeft: '0 !important',
    justifyContent: 'center',
    textAlign: 'center',
    width: { xs: '50%', sm: '322px' },
    borderBottom: outcome === 'Timeline' ? 'solid 1px #00AB55 !important' : 'solid 1px  transparent',
    display: 'none !important',
    '@media(max-width: 1240px)': {
        display: 'inline-flex !important'
    }
});
export const activeStepTitleStyle = {
    mt: { xs: 0.5, sm: 1 },
    mb: { xs: 1, sm: 2 },
    width: '100%',
    textAlign: 'center',
    '@media (max-width: 768px)': {
        fontSize: '13px',
    },
};
export const activeStepTextStyle = {
    m: 'auto',
    mb: { xs: 1.5, sm: 3 },
    textAlign: 'center',
    '@media (min-width:990px)': { width: '60%' },
    '@media (max-width: 768px)': {
        fontSize: '12px',
        mb: 1,
    },
};
export const footerButtonBoxStyle = {
    width: '100%',
    py: { xs: 1, sm: 2 },
    mt: 'auto',
    position: 'sticky',
    bottom: 0,
    bgcolor: 'background.paper',
    zIndex: 99,
    borderTop: '1px solid',
    borderColor: 'divider',
    paddingBottom: 'env(safe-area-inset-bottom)',
};
export const backButtonStyle = {
    minWidth: '78px',
    minHeight: '36px',
    p: '6px 8px',
    borderRadius: 1,
    color: '#637381'
};
export const nextButtonStyle = type => (
    type === 'createLead' || type === 'followup' ? {
        px: { xs: 3.5, sm: 8 },
        ml: '16px',
        minHeight: '40px',
        minWidth: type === 'contactLead' ? '180px' : '200px',
        padding: '5px 30px !important'
    } : {
        px: { xs: 3.5, sm: 8 },
        py: 0.75,
        ml: '16px',
        minHeight: '40px',
        minWidth: type === 'contactLead' ? '180px' : '200px',
        padding: '5px 30px !important'
    }
);
export const markAsCompleteBtnStyle = type => ({
    px: { xs: 3.5, sm: 8 },
    py: 0.75,
    ml: '16px',
    minHeight: '40px',
    minWidth: type === 'contactLead' ? '180px' : '200px',
    padding: '5px 30px !important',
    '.MuiLoadingButton-loadingIndicator': {
        position: 'relative',
        marginRight: '10px',
        left: 0
    }
}
);
export const popupMainStackStyle = value => ({
    p: { xs: '8px', sm: '16px' },
    pt: { xs: '12px', sm: '24px' },
    position: 'relative',
    width: value === '' ? 'calc(100% - 85px)' : 'calc(100% - 528px)',
    height: 'auto',
    minHeight: 'auto',
    flexDirection: 'row',
    gap: 2,
    '@media (max-width: 1280px)': {
        flexDirection: 'column',
        minHeight: 'auto',
        height: 'auto',
        width: '100%',
    }
});
export const drawerStyle = (drawerOpen) => ({
    position: 'fixed',
    width: 370,
    maxWidth: '100%',
    display: drawerOpen ? 'flex' : 'none',
    mt: '0 !important',
    height: '100%',
    right: '16px',
    top: '68px',
    '@media(max-width: 1440px)': {
        width: 300,
    },
    '@media(max-width: 1300px)': {
        width: 270,
    },
    '@media(max-width: 1240px)': {
        display: 'none !important'
    },
    '.MuiDrawer-paper': {
        width: 370,
        position: 'absolute',
        maxWidth: '100%',
        boxShadow: 'none',
        zIndex: 1,
        overflow: 'hidden',
        '@media(max-width: 1440px)': {
            width: 300,
        },
        '@media(max-width: 1300px)': {
            width: 270,
        },
    }
});
export const drawerHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    p: '20px 20px 20px 20px',
    justifyContent: 'space-between',
    borderBottom: 'solid 1px rgba(145, 158, 171, 0.24)'
};
export const gridContainerStyle = (type, ContactedCount, activeStep) => ({
    maxWidth: type === 'followup' && ContactedCount !== 0 && activeStep === 0 && 'calc(100% - 370px)',
    '@media(max-width: 1240px)': {
        maxWidth: '100%',
    },
});
export const leftBoxInnerStyle = (expandLayout, noBackground = false) => ({
    background: '#FFFFFF',
    borderRadius: 2,
    width: expandLayout ? '478px' : '100%',
    pt: noBackground ? '0px' : '30px',
    pb: '30px',
    px: '24px',
    minHeight: 'calc(100dvh - 128px)',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: noBackground ? 'none' : '0 0 1px rgba(145, 158, 171, 0.2), 0 1px 3px rgba(145, 158, 171, 0.08)',
    '@media (max-width: 1280px)': {
        width: '100% !important',
        height: 'auto',
    },
    '@media (max-width: 768px)': {
        px: '12px',
        pt: noBackground ? '0px' : '12px',
        pb: '12px',
    }
});
export const rightBoxInnerStyle = (expandLayout, value) => ({
    minWidth: isEmpty(value) ? '56px' : '470px',
    maxWidth: isEmpty(value) ? '70px' : expandLayout ? '100%' : '500px',
    display: 'flex',
    gap: '12px',
    height: 'calc(100vh - 128px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: isEmpty(value) ? '70px' : expandLayout ? '100%' : '500px',
    position: 'fixed',
    top: '92px',
    right: '16px',
    borderRadius: 2,
    '@media (max-width: 1280px)': {
        width: '100% !important',
        display: 'none'
    }
});
export const tabContentBoxStyle = {
    background: '#FFFFFF',
    borderRadius: 2,
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    boxShadow: '0 0 1px rgba(145, 158, 171, 0.2), 0 1px 3px rgba(145, 158, 171, 0.08)',
    pt: 0,
    pb: 0,
};

export const offerMainBoxStyle = {
    marginBottom:'20px !important',
};

export const offerBoxStyle = {
   
    padding:'15px',
};

export const offerContentStyle = {
    borderBottom: 'solid 1px',
    borderColor: '#919EAB3D',
    marginLeft:'20px',
    marginRight:'20px',
    padding:'20px',
};


export const timeLineTypoV2 = {
    color: 'grey',
    fontSize: '14px',
    lineHeight: '16.45px',
    marginBottom: '8px',
    fontWeight: 600
};


export const tabsMainBoxStyle = {
    border: '1px solid rgba(145, 158, 171, 0.12)',
    borderRadius: 2,
    p: '4px',
    height: 'fit-content',
    bgcolor: '#FFFFFF',
    boxShadow: '0 0 1px rgba(145, 158, 171, 0.2), 0 1px 3px rgba(145, 158, 171, 0.08)',
    '.MuiTabs-indicator': {
        display: 'none'
    },
};
export const tabButtonStyle = {
    flexDirection: 'column',
    mr: '0 !important',
    minWidth: 56,
    minHeight: 56,
    borderRadius: 1.5,
    textTransform: 'none !important',
    overflow: 'visible',
    fontSize: '11px',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    '&:hover': {
        bgcolor: 'rgba(145, 158, 171, 0.08)',
    },
    '&.Mui-selected': {
        bgcolor: (theme) => `${alpha(theme.palette.primary.main, 0.08)}`,
        color: 'primary.main',
        fontWeight: 600,
    }
};
export const listHeaderBoxStyle = {
    boxShadow: '0px -1px 0px 0px #919EAB3D inset',
    display: 'flex',
    justifyContent: 'space-between',
    p: '14px 24px',
    alignItems: 'center'
};
export const listContentBoxStyle = {
    maxHeight: 'calc(100vh - 180px)',
    overflow: 'auto',
    'ul.MuiTimeline-root': {
        margin: 0
    },
    '.MuiPaper-root': {
        maxWidth: '100%'
    }
};
export const listCounterBoxStyle = {
    padding: '0px 4px',
    background: '#B72136',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#fff',
    borderRadius: '10px',
    minWidth: '31px',
    minHeight: '20px',
    position: 'absolute',
    fontWeight: 700,
    top: '-8px',
    right: 0,
    border: '1px solid #FFFFFF',
};
export const leadListCard = (isLight, isArchived, autoReminder, isArchivePending) => ({
    background: 'transparent !important',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    margin: '24px 0px 0',
    minHeight: 'auto',
    height: 'auto',
    width: 'calc(100% - 40px)',
    overflow: 'auto',
    boxShadow: 'none',
    border: 'none',
    '&:hover': {
        boxShadow: 'none',
        background: 'none'
    },
    pointerEvents: isArchived || isArchivePending ? 'none' : null,
    bgcolor: isArchivePending && 'rgb(235 235 235) !important',
});
export const leadTaskPopover = (data) => ({
    color: data?.datetime_human.includes('now' || 'NOW') ? 'common.lightGreen' : 'common.red',
    fontWeight: '600',
    padding: '0 8px 0 0',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    mb: '0',
});
export const tagChipStyle = {
    background: '#FF484229 !important',
    height: '22px',
    borderRadius: 1,
    p: '3px',
    fontSize: '14px',
    fontWeight: 600,
    color: '#B71D18',
    '.MuiChip-label': {
        p: '0 5px'
    }
};

export const getPriorityBgColor = (priority) => {
    if (priority === 'HIGH') {
        return '#ffa500 !important';
    }
    if (priority === 'LOW') {
        return '#D3D3D3 !important';
    }
    if (priority === 'URGENT') {
        return '#FF484229 !important';
    }
    return '#0000FF !important';
};
export const getPriorityTextColor = (priority) => {
    if (priority === 'HIGH') {
        return '#fff !important';
    }
    if (priority === 'LOW') {
        return '#000 !important';
    }
    if (priority === 'URGENT') {
        return '#B71D18 !important';
    }
    return '#fff !important';
};

export const tagChipStyleV2 = (priority) => ({
    background: getPriorityBgColor(priority),
    height: '22px',
    borderRadius: 1,
    p: '3px',
    fontSize: '14px',
    fontWeight: 600,
    color: getPriorityTextColor(priority),
    '.MuiChip-label': {
        p: '0 5px'
    }
});
export const tagsChipBoxStyle = {
    display: 'flex',
    width: '100%',
    gap: '12px',
    mt: 1
};

export const cardMainArea = () => ({
    overflowY: 'auto',
    height: 'auto',
    minHeight: 'auto',
});
export const cardMainAreaWrapper = (currentStep, expandLayout) => ({
    py: 0,
    pt: 0,
    flex: currentStep === 0 ? 1 : 'unset',
    display: currentStep === 0 ? 'flex' : 'block',
    flexDirection: currentStep === 0 ? 'column' : 'unset',
    justifyContent: currentStep === 0 ? 'flex-start' : 'unset',
    alignItems: currentStep === 0 ? 'center' : 'unset',
    '.MuiButtonGroup-root': {
        flexDirection: expandLayout ? 'column' : 'row'
    },
    '@media (max-width: 1280px)': {
        flexDirection: 'row'
    },
    ...cardMainArea(currentStep)
});